var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-divider",style:({textAlign: _vm.align})},[(_vm.text.length > 0)?_c('span',[_c('b',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }